import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { STAGES_MAP } from 'redux/modules/journeys/stop-status-log';
import { Tooltip } from '@ontruck/orc';
import { StyledActionButton } from './styled';

import SelectHour from './select-hour';

import {
  featurePreferenceToggle,
  ADVANCE_JOURNEY_ALLOW_TO_SET_TIME,
} from 'modules/preferences-manager/preferences';
import { injectIntl } from 'react-intl';

const showETAButtonStages = [STAGES_MAP.PENDING];

const StageActions = ({
  etaError,
  opened,
  stopType,
  stage,
  handleAdvance,
  onGetEtaClick,
  className,
  previousStageTimeDone,
  intl,
}) => {
  const t = intl.messages.modules.journey.stop_status_log.stage_actions;
  const [showInput, setShowInput] = useState(false);
  const showGetEtaButton = showETAButtonStages.includes(stage);
  const showTooltip = opened && !!etaError;
  const stageStatus =
    typeof t.status[stage] === 'string' ? t.status[stage] : t.status[stage][stopType];
  const advanceTimeWithHourEnabled = featurePreferenceToggle(ADVANCE_JOURNEY_ALLOW_TO_SET_TIME);

  const handleStageClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (advanceTimeWithHourEnabled) {
      setShowInput(true);
    } else {
      handleAdvance(e);
    }
  };

  const getEtaButton = (
    <StyledActionButton disabled={!opened || !!etaError} onClick={onGetEtaClick}>
      {t.get_eta}
    </StyledActionButton>
  );

  return (
    <div className={className}>
      {!showInput && (
        <>
          <StyledActionButton
            disabled={!opened}
            onClick={handleStageClick}
            data-e2e="journey_detail__advanceJourney"
          >
            {stageStatus}
          </StyledActionButton>

          {showGetEtaButton && !showTooltip && getEtaButton}
          {showGetEtaButton && showTooltip && (
            <Tooltip
              component={t.errors[etaError] ? t.errors[etaError] : t.errors.default}
              skin="light"
              position="top"
              align="center"
              size="M"
              bodySize="M"
              alwaysVisible
            >
              {getEtaButton}
            </Tooltip>
          )}
        </>
      )}
      {showInput && (
        <SelectHour
          previousStageTimeDone={previousStageTimeDone}
          setShowInput={setShowInput}
          handleAdvance={handleAdvance}
        />
      )}
    </div>
  );
};

StageActions.propTypes = {
  stopType: PropTypes.string,
  stage: PropTypes.string,
  className: PropTypes.string,
  etaError: PropTypes.string,
  onAdvanceClick: PropTypes.func,
  onETAclick: PropTypes.func,
  opened: PropTypes.func,
};

export default injectIntl(StageActions);
